import React, { useEffect } from 'react'
import gsap, { Power3 } from 'gsap'

const GalleryHeaderText: React.FC = () => {
	useEffect(() => {
		let ctx = gsap.context(() => {
			gsap.timeline({})
				.from('.gallery-header-text-header', {
					y: 200,
					duration: 1.5,
					ease: Power3.easeOut,
				})
				.from('.gallery-header-text-sub-header', { y: 200, duration: 1 }, 0.5)
		})

		return () => ctx.revert()
	}, [])

	return (
		<div className='gallery-header-text--container'>
			<h1 className='gallery-header-text-header'>Mummy Lilian’s Big 50 Gallery!</h1>
			<h5 className='gallery-header-text-sub-header'>
				Pictures they say speak louder than words! A beautiful mother worthy of emulation in all ramifications!
			</h5>
		</div>
	)
}

export default GalleryHeaderText
